import { render, staticRenderFns } from "./TimeOffApprovers.vue?vue&type=template&id=10cd5b67&"
import script from "./TimeOffApprovers.vue?vue&type=script&lang=js&"
export * from "./TimeOffApprovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports